<template>
  <div class="AgentsAndNumbersView">
    <PageHeader title="Kody Promocyjne"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <PromotionCodesList />
    </ShPageLayout>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        Kody Promocyjne
      </template>
      <template #description>
        <PopupHints hint-template-name="promotionCodes" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PromotionCodesList from '@/components/PromotionCodes/PromotionCodesList';


export default {
  name: 'AgentsAndNumbers',
  components: {
    PageHeader,
    PopupHints,
    ShPageLayout,
    ShModalWindow,
    PromotionCodesList,
  },

  mixins: [PopupHintsUtils],

  data() {
    return {
      isModalWithAddNewAgentFormVisible: false,
      isModalWithAgentDataDetailsVisible: false,
      isModalWithNumberVerificationVisible: false,
      agentDetailsData: {},
      verifiedNumber: null,
      numberToBeAssigned: null,
    };
  },

  created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('agentsAndNumbersModalOpen');
  },
};
</script>
